import PropTypes from 'prop-types';

const FeatureCard = ({ title = '', description = '', icon: Icon = null }) => (
  <div key={title} className="p-8 rounded-lg bg-gray-50 shadow">
    <div className="flex flex-col items-center justify-center text-center space-y-8 -mt-14">
      <span className="p-3 rounded-md shadow-lg bg-gradient-to-br from-secondary-500 to-primary-600 text-white">
        {Icon ? <Icon className="w-6 h-6" /> : null}
      </span>
      <div className="space-y-5">
        <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
        <p className="text-gray-500">{description}</p>
      </div>
    </div>
  </div>
);

FeatureCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.elementType, PropTypes.node]),
};

export default FeatureCard;
